import { Alert } from "@/src/lib/productAlert";
import { Text } from "@/src/components/ui/BrandText";
import { text as uiText } from "@/src/theme/tokens";
import React from "react";
import { Linking, type GestureResponderEvent } from "react-native";
import { linkifyPostText } from "../lib/postLinks";

type Props = {
  text: string;
  shortTextOnly: boolean;
  onOpenPost: () => void;
};

export function PostText({ text, shortTextOnly, onOpenPost }: Props) {
  const segments = React.useMemo(() => linkifyPostText(text), [text]);

  const handleOpenLink = React.useCallback(async (event: GestureResponderEvent, url: string) => {
    event.stopPropagation?.();
    try {
      await Linking.openURL(url);
    } catch (error: any) {
      if (__DEV__) console.warn("[post] link open failed", error?.code ?? "unknown");
      Alert.alert("Ouverture impossible", "Le lien n'a pas pu être ouvert.");
    }
  }, []);

  return (
    <Text
      onPress={onOpenPost}
      accessibilityRole="button"
      accessibilityLabel="Ouvrir la publication"
      accessibilityHint="Voir la publication en détail"
      style={{
        color: uiText.primary,
        fontSize: shortTextOnly ? 20 : 15,
        lineHeight: shortTextOnly ? 28 : 21,
        fontWeight: shortTextOnly ? "700" : "400",
        paddingVertical: shortTextOnly ? 6 : 0,
      }}
    >
      {segments.map((segment, index) =>
        segment.kind === "link" ? (
          <Text
            key={`${segment.url}-${index}`}
            onPress={(event) => handleOpenLink(event, segment.url)}
            accessibilityRole="link"
            accessibilityLabel={`Ouvrir le lien ${segment.value}`}
            style={{ color: uiText.brand, textDecorationLine: "underline" }}
          >
            {segment.value}
          </Text>
        ) : (
          <React.Fragment key={`text-${index}`}>{segment.value}</React.Fragment>
        )
      )}
    </Text>
  );
}
